export default "__VITE_ASSET__BoA5g_nf__"